var _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "currentColor",
    d: "M1.834 6.171C1.834 4.972 2.806 4 4.005 4v0c.726 0 1.404-.363 1.807-.967L5.834 3c.416-.625 1.118-1 1.869-1h1.596c.75 0 1.452.375 1.868 1l.022.033c.403.604 1.081.967 1.807.967v0c1.2 0 2.171.972 2.171 2.171V10a4 4 0 01-4 4H5.834a4 4 0 01-4-4V6.171z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.501,
    cy: 8.667,
    r: 2.667,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "currentColor"
  })));
}

export default SvgCamera;